import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import { Link } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";

import LogoText from "components/common/LogoText";

import LoginIcon from "icons/Login";
import MenuIcon from "icons/Menu";

import { LINKS } from "@constants";
import eventsService, { EVENTS } from "services/events";

const ListItemStyled = styled(ListItem)`
  a {
    color: var(--surface-background);
    font-weight: 400;
    text-decoration: none;
  }
`;

const MobileHeader = ({ pages }) => {
  const [mainNavOpen, setMainNavOpen] = React.useState(false);

  return (
    <Box
      sx={{
        display: { xs: "flex", sm: "flex", md: "none" },
        flexGrow: 1,
        alignItems: "center",
        minHeight: "64px",
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-main-nav"
            aria-haspopup="true"
            onClick={() => setMainNavOpen(true)}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
          <Divider orientation="vertical" />
          <LogoText showMobileLogo />
        </Box>

        <Drawer
          anchor="left"
          open={mainNavOpen}
          onClose={() => setMainNavOpen(false)}
          sx={{
            display: { xs: "flex", sm: "flex", md: "none" },
            flexDirection: "column",
            height: "100%",
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: "80%",
              background: "#F4F4F8",
              padding: "32px 8px",
            },
          }}
        >
          <Box role="presentation" sx={{ flexGrow: 1 }}>
            <List id="menu-main-nav">
              {pages.map(({ label, href, isNewTab }) => (
                <ListItemStyled key={label} disablePadding>
                  <ListItemButton>
                    <ListItemText>
                      <Link href={href} sx={{ display: "block" }}>
                        {label}
                      </Link>
                    </ListItemText>
                  </ListItemButton>
                </ListItemStyled>
              ))}
              <ListItemStyled disablePadding>
                <ListItemButton>
                  <ListItemText>
                    <Link
                      href={LINKS.respeecherForBusiness}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ display: "block" }}
                    >
                      For Business
                    </Link>
                  </ListItemText>
                </ListItemButton>
              </ListItemStyled>
            </List>
          </Box>
          <Box>
            <Button
              component={Link}
              href={LINKS.login}
              startIcon={<LoginIcon />}
              variant="contained"
            >
              Log In
            </Button>
          </Box>
        </Drawer>
      </Box>

      <Button
        component={Link}
        href={LINKS.signup}
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
      >
        Try For Free
      </Button>
    </Box>
  );
};

MobileHeader.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MobileHeader;
